import versionInfo from '../../../version.json';

export const environment = {
  production: false,
  enableAnalytics: false,
  version: `QA Build ${versionInfo.version}`,
  apiUrl: 'https://sdsstage.healthcarebc.ca/sds.api/api/',
  apiWindowsAuthUrl: 'https://sdsstage.healthcarebc.ca/sds.windowsauth/api/Login',
  apiWindowsAuthBaseUrl: 'https://sdsstage.healthcarebc.ca/',
  recaptchaSiteKey: '6Le9FtsrAAAAAPveb30buTZWDz8Mpl7apyespA0Z'
};